export enum FilterType {

    HIDE_INACTIVE_QUOTE_REQUESTS = 'HIDE_INACTIVE_QUOTE_REQUESTS',
    TRADES_OF_THE_DAY = 'TRADES_OF_THE_DAY'
}